import type { ReactNode } from 'react';
import React, { Fragment, useState, useContext, useCallback } from 'react';

import { useEditSource } from '@confluence/edit-common/entry-points/useEditSource.ts';

import { EditContentButtonPreloaderContext } from './EditContentButtonPreloaderContext.ts';

export interface ICreateContentButtonPreloader {
	children: ReactNode;
	editSource?: string;
}

export const CreateContentButtonPreloader = ({
	children,
	editSource = '',
}: ICreateContentButtonPreloader) => {
	const preloader = useContext(EditContentButtonPreloaderContext); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
	const [doPreload, setDoPreload] = useState(false);

	const [{ editSource: contextEditSource }, { setEditSource }] = useEditSource();

	const onHover = useCallback(() => {
		setEditSource(editSource);
		setDoPreload(true);
	}, [editSource, setEditSource]);

	return (
		<Fragment>
			<div onMouseEnter={onHover} onFocus={onHover}>
				{children}
			</div>
			{editSource === contextEditSource && doPreload && preloader ? preloader({}) : null}
		</Fragment>
	);
};
